import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  connect() {
    this.select = new TomSelect(this.element, {
      maxOptions: null,
      allowEmptyOption: true,
      create: false,
      dropdownParent: this.element.closest("dialog") ? null : "body",
      placeholder: "Cerca operatore…",
      plugins: { dropdown_input: {} },
      render: {
        no_results: () => '<div class="no-results">Nessun operatore trovato</div>',
      },
    });
    this.select.dropdown.classList.add("operator-select-dropdown");
    this.select.control_input.setAttribute("aria-label", "Cerca operatore");
    this.dialog = this.element.closest("dialog");
    if (this.dialog) {
      this.select.positionDropdown = () => {
        const rect = this.select.control.getBoundingClientRect();
        Object.assign(this.select.dropdown.style, {
          position: "fixed", top: `${rect.bottom}px`, left: `${rect.left}px`, width: `${rect.width}px`,
        });
        this.select.dropdown_content.style.maxHeight = `${Math.max(80, Math.min(176, window.innerHeight - rect.bottom - 60))}px`;
      };
      this.reposition = () => { if (this.select.isOpen) this.select.positionDropdown(); };
      this.dialog.addEventListener("scroll", this.reposition, true);
    }
  }

  disconnect() {
    this.dialog?.removeEventListener("scroll", this.reposition, true);
    this.select?.destroy();
  }
}
